<template>
    <BaseButton
        v-bind="props"
        :class="[$style.icon_button_override, iconStyles[`size_${props.size}_override`]]"
    >
        <Icon
            v-if="props.icon"
            :name="props.icon"
            :class="iconStyles.icon"
        />
        <div
            v-else
            :class="iconStyles.icon"
        >
            <slot />
        </div>
    </BaseButton>
</template>

<script lang="ts" setup>
import { type HTMLAttributes } from 'vue'

import { type IconNameType } from '@/components/Icon'
import Icon from '@/components/Icon/Icon.vue'

import BaseButton, { type BaseButtonProps } from './components/BaseButton.vue'
import iconStyles from './styles/icon.module.css'

type Props = {
    icon?: IconNameType
} & BaseButtonProps &
    /* @vue-ignore */ Omit<HTMLAttributes, 'hidden'>

const props = withDefaults(defineProps<Props>(), {
    type: 'button',
    size: 'm',
    width: 'normal',
    color: 'purple-400',
})
</script>
<style module>
.icon_button_override {
    color: var(--text);
    --background-color: var(--main);
}
</style>
